import { Stack, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { getButtonStyle, typedEntries, isSubscriptionExpert } from '@shared/entity';
import { FilterTableButton } from './FilterTableButton';
import { useSubscriptionPlan } from '@shared/store';

type FilterButtonsProps<T extends string> = {
  activeFilter: T;
  filterButtonsConfig: Record<T, { defaultMessage: string; id: string; requiresExpert?: boolean }>;
  onChange: (key: T) => void;
};

const FilterButtons = <T extends string>(props: FilterButtonsProps<T>) => {
  const { activeFilter, filterButtonsConfig, onChange } = props;
  const intl = useIntl();
  const plan = useSubscriptionPlan();
  const isExpert = isSubscriptionExpert(plan);

  return (
    <Stack direction="row" spacing={2} justifyContent="flex-start">
      {typedEntries(filterButtonsConfig).map(([key, { defaultMessage, id, requiresExpert }]) => {
        const disabled = Boolean(requiresExpert && !isExpert);
        const button = (
          <FilterTableButton
            key={key}
            variant={getButtonStyle(activeFilter, key)}
            setTableView={() => onChange(key)}
            text={intl.formatMessage({ defaultMessage, id })}
            disabled={disabled}
          />
        );

        if (disabled) {
          return (
            <Tooltip
              key={key}
              title={intl.formatMessage({
                id: 'visitDetailGrid.soldItemsRevenueDisabledMessage',
                defaultMessage: 'Dostupné v plánu EXPERT. Aktivujte ve vašem profilu.',
              })}
            >
              <span>{button}</span>
            </Tooltip>
          );
        }

        return button;
      })}
    </Stack>
  );
};

export default FilterButtons;
